/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SecurityModule
 */

const moduleName = 'security';
const componentName = 'jwt-server-profile-modal';
const prefix = `${moduleName}.${componentName}`;

export const modalTitleEdit = `${prefix}.modalTitleEdit`;
export const sectionTitleGeneral = `${prefix}.sectionTitleGeneral`;
export const modalTitleNew = `${prefix}.modalTitleNew`;
export const nameInputLabel = `${prefix}.nameInputLabel`;
export const nameInputPlaceholder = `${prefix}.nameInputPlaceholder`;
export const issuerInputLabel = `${prefix}.issuerInputLabel`;
export const issuerInputPlaceholder = `${prefix}.issuerInputPlaceholder`;
export const jwtFileInputLabel = `${prefix}.jwtFileInputLabel`;
export const jwtFileInputPlaceholder = `${prefix}.jwtFileInputPlaceholder`;
export const sectionTitleProtectedResource = `${prefix}.sectionTitleProtectedResource`;
export const enableProtectedResourceMetadataLabel = `${prefix}.enableProtectedResourceMetadataLabel`;
export const metadataUrlPathLabel = `${prefix}.metadataUrlPathLabel`;
export const metadataUrlPathPlaceholder = `${prefix}.metadataUrlPathPlaceholder`;
export const authorizationServersLabel = `${prefix}.authorizationServersLabel`;
export const authorizationServersPlaceholder = `${prefix}.authorizationServersPlaceholder`;
export const supportedScopesLabel = `${prefix}.supportedScopesLabel`;
export const supportedScopesPlaceholder = `${prefix}.supportedScopesPlaceholder`;
export const resourceDocumentationLabel = `${prefix}.resourceDocumentationLabel`;
export const resourceDocumentationPlaceholder = `${prefix}.resourceDocumentationPlaceholder`;

export const ENGLISH = {
    [modalTitleEdit]: 'Edit JWT Server Profile',
    [sectionTitleGeneral]: 'General',
    [modalTitleNew]: 'New JWT Server Profile',
    [nameInputLabel]: 'Name',
    [nameInputPlaceholder]: 'Enter Name',
    [issuerInputLabel]: 'Issuer',
    [issuerInputPlaceholder]: 'Enter Issuer',
    [jwtFileInputLabel]: 'Upload or Paste JWKS File',
    [jwtFileInputPlaceholder]: 'Paste JWKS contents',
    [sectionTitleProtectedResource]: 'JWT Protected Resource Config',
    [enableProtectedResourceMetadataLabel]: 'Enable Protected Resource Metadata',
    [metadataUrlPathLabel]: 'Metadata URL Path',
    [metadataUrlPathPlaceholder]: 'Enter Metadata URL Path',
    [authorizationServersLabel]: 'Authorization Servers',
    [authorizationServersPlaceholder]: 'Enter Authorization Server URL',
    [supportedScopesLabel]: 'Supported Scopes',
    [supportedScopesPlaceholder]: 'Enter Scope',
    [resourceDocumentationLabel]: 'Resource Documentation',
    [resourceDocumentationPlaceholder]: 'Enter Documentation URL Path',
};
